import { GetServerSideProps } from 'next';
import Head from 'next/head';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ProfsPage from '../profe-page/profe-page';
import previewMain from '../../public/preview/preview-main.png';
import { WorksProps } from '../works/works';
import { Footer, Header } from '../../components';
import staticWorks from '../../utils/works';
import menu from '../../utils/menu';

export default function WorksPage({ works }: WorksProps) {
  return (
    <>
      <Head>
        <title>
          Mavinx Web Development: Empowering Businesses with Cutting-Edge
          Websites
        </title>
        <meta
          property="og:title"
          content="Mavinx Web Development: Empowering Businesses with Cutting-Edge
          Websites"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Web Development: Empowering Businesses with Cutting-Edge
          Websites"
        />
        <meta property="og:type" content="product" />
        <meta
          name="keywords"
          content="web development services, Mavinx web development, cutting-edge websites, online success, front-end development, back-end development, responsive design, e-commerce integration, content management systems, creativity, functionality, user experience, custom web applications, scalable solutions, secure websites, business goals, target audience, professional web development, Mavinx trusted partner"
        />

        <meta
          property="og:description"
          content="Mavinx develops cutting-edge websites that help companies succeed online. Discover our skills in front-end and back-end development, responsive design, e-commerce integration, and CMS. Discover how our web developers blend creativity, functionality, and user experience to build aesthetically attractive and intuitive websites that capture audiences."
        />
        <meta
          name="description"
          content="Mavinx develops cutting-edge websites that help companies succeed online. Discover our skills in front-end and back-end development, responsive design, e-commerce integration, and CMS. Discover how our web developers blend creativity, functionality, and user experience to build aesthetically attractive and intuitive websites that capture audiences."
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <ProfsPage
        awards={{
          title: 'awards',
          leadText:
            'Leading review & rating piatforms name us the top mobile app development company',
          leadImage: '/ios/rate.png',
          list: [
            {
              image: '/awards/item-1.jpg',
              text: 'Top Web Developers in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-2.jpg',
              text: 'Top Web Design in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-3.jpg',
              text: 'Top Swift App Development in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-4.jpg',
              text: 'Top Web Developers in Ukraine',
              title: 'Clutch',
            },
            {
              image: '/awards/item-5.jpg',
              text: 'Upwork TOP RATED 2022',
              title: 'Clutch',
            },
            {
              image: '/awards/item-6.jpg',
              text: 'Top Web Developers Companies 2020',
              title: 'Clutch',
            },
          ],
        }}
        works={[{ ...works[2] }, { ...works[4] }]}
        intro={{
          bg: '/webservice/intro-bg.jpg',
          btn: 'Estimate my webSIte',
          h1: (
            <>
              web
              <br />
              Development
            </>
          ),
          h2: 'services',
        }}
        info="Our team divide website development into 2 stages. At the end of each stage, we provide you with the demo presentation, so you could stay on the same page with us during the whole development process. We are happy to tell you more about our full stack web development."
        tecnologic={{
          title: 'Website types',
          list: [
            {
              image: '/webservice/device-1.jpg',
              name: 'Landing Page',
            },
            {
              image: '/webservice/device-2.jpg',
              name: 'Corporate Website',
            },
            {
              image: '/webservice/device-3.jpg',
              name: 'E-Commerce Website',
            },
          ],
        }}
        service={{
          title: 'web Development Services',
          list: [
            {
              image: '/webservice/service-1.jpg',
              title: 'Custom Web Application Development',
              text: 'To optimize workflows, we are ready to integrate existing applications through the web developments or make site from scratch. For example, you may need E-Commerce, Online Training & Courses, Customer Relationship Management (CRM), Enterprise Resource Planning (ERP). If so, our web development company is here!',
            },
            {
              image: '/webservice/service-2.jpg',
              title: 'No Cookie-Cutter Solutions',
              text: 'In order to fulfill the tasks assigned to us, our front-end and back-end developers use advanced technologies, techniques, and tools. We can provide your project with a variety of services such as API Development & Integration, Quality Assurance, Implementation & Deployment, Integration Services and Applications and more.',
            },
            {
              image: '/webservice/service-3.jpg',
              title: 'Diverse Coding Experience',
              text: 'Our experience in web developments is based on the knowledge that we improve every day. Our wealth of knowledge is full of Java, JavaScript, PHP, Laravel, Python, Lumen, Objective-C, AngularJS, ReactJS, NodeJS, Typescript, HTML5, CSS3 and so much more.',
            },
            {
              image: '/webservice/service-4.jpg',
              title: 'Maintenance, Monitoring, & Support',
              text: 'Upon completion of the task, we guarantee its quality by deeds. You can count on support, monitoring, testing, and maintenance of projects after their completion. Our team is always in touch to keep your web project up and running.',
            },
          ],
        }}
        devtool={{
          title: 'web Development technologies we work with',
          list: [
            { image: '/webservice/devtool-1.png', name: 'PHP' },
            { image: '/webservice/devtool-2.png', name: 'laravel' },
            { image: '/webservice/devtool-3.png', name: 'React JS' },
            { image: '/webservice/devtool-4.png', name: 'Python' },
            { image: '/webservice/devtool-5.png', name: 'Next JS' },
          ],
        }}
      />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<WorksProps> = async () => {
  try {
    const works = staticWorks;
    return {
      props: {
        works,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
